import {
  GraphQLLayoutService,
  RestLayoutService,
  constants,
} from '@sitecore-jss/sitecore-jss-react';
import config from '../temp/config';
import { clientFactory } from './client-factory';

export class LayoutServiceFactory {
  /**
   * @param {string} [siteName] - overrides the build-time site name. Needed for
   * client-side calls on the foodservice/Canadian hosts, which share this bundle.
   * @param {string} [configurationName] - overrides the build-time layout service
   * configuration. The generated config uses `default`, which returns a valid
   * response but WITHOUT this app's context extensions (globalContent,
   * trademarkReplacements) — those are only registered on the `jss` configuration,
   * which is what the proxy uses server-side.
   */
  create(siteName, configurationName) {
    const site = siteName || config.sitecoreSiteName;

    return process.env.REACT_APP_FETCH_WITH === constants.FETCH_WITH.GRAPHQL
      ? new GraphQLLayoutService({
          clientFactory,
          siteName: site,
        })
      : new RestLayoutService({
          apiHost: config.sitecoreApiHost,
          apiKey: config.sitecoreApiKey,
          siteName: site,
          configurationName: configurationName || config.layoutServiceConfigurationName,
        });
  }
}

export const layoutServiceFactory = new LayoutServiceFactory();
